/** Dependencies */
import React from 'react';
import { Outlet } from 'react-router-dom';

function PermissionDetails() {
  return <Outlet />;
}

export default PermissionDetails;
